const DMPConnect = {
    DMPStatus: {
        DMPExist: 1,
        DMPIsClosed: 2,
        DMPNotFound: 3,
        DMPError: 4,
    },

    Sex: {
        UnknownSex: 1,
        Male: 2,
        Female: 3,
    },

    UserAuthorizationStatus: {
        AuthorizationError: 1, /// Means that the DMP does not exists or was closed.
        AuthorizationExist: 2,
        AuthorizationExpired: 3,
        AuthorizationDenied: 4,
        NoAuthorization: 5,
    },

    DocumentVisibility: {
        Normal: 1,
        PatientHidden: 2,
        HealthcareProfessionalHidden: 4,
        GuardianHidden: 8,
    },

    DocumentFormat: {
        // Unstructured documents.
        PlainText: 1,
        RtfText: 2,
        JpgImage: 3,
        TiffImage: 4,
        PdfApplication: 5,

        // Structured documents.
        VsmDocument: 6,
        CrBiologie: 7,
    },

    UserAuthenticationMode: {
        InternetProtocol: 1,
        InternetProtocolPassword: 2,
        Kerberos: 3,
        MobileOneFactorUnregistered: 4,
        MobileTwoFactorUnregistered: 5,
        MobileOneFactorContract: 6,
        MobileTwoFactorContract: 7,
        Password: 8,
        PasswordProtectedTransport: 9,
        PreviousSession: 10,
        PublicKeyX509: 11,
        PublicKeyPGP: 12,
        PublicKeySPKI: 13,
        PublicKeyXMLDigitalSignature: 14,
        Smartcard: 15,
        SmartcardPKI: 16,
        SoftwarePKI: 17,
        Telephony: 18,
        TelephonyNomadic: 19,
        TelephonyPersonalized: 20,
        TelephonyAuthenticated: 21,
        SecureRemotePassword: 22,
        SSL_TLSCertificateBasedClientAuthentication: 23,
        TimeSyncToken: 24,
        Unspecified: 25,
    },

    PerformerRole: {
        Actor: 1,
        MainActor: 2,
        Assistant: 3,
    },

    GuardianStatus: {
        NoGuardianDefined: 1,
        GuardianDefined: 2,
    },

    GuardianAction: {
        IgnoreGuardianSetup: 1,
        AddGuardian: 2,
        RemoveGuardian: 3,
    },

    LegalRepresentantRole: {
        Father: 1,
        Mother: 2,
        StepFather: 3,
        StepMother: 4,
        GrandFather: 5,
        GrandMother: 6,
        GrandGrandFather: 7,
        GrandGrandMother: 8,
        Aunt: 9,
        Uncle: 10,
        Brother: 11,
        Sister: 12,
        Guardian: 13,
    },

    Gender: {
        UnknownGender: 1,
        M: 2,
        Mme: 3,
    },

    UserAuthorizationAction: {
        AddAuthorization: 1,
        RemoveAuthorization: 2,
    },

    IdentifierType: {
        // Patient identifier
        IdentifierType_PatientIns: 1,
        IdentifierType_PatientInsC: 2,
        // National identifier
        IdentifierType_NationalIdentifierRpps: 3,
        IdentifierType_NationalIdentifierAdeli: 4,
        IdentifierType_NationalIdentifierSirius: 5,
        IdentifierType_NationalIdentifierStudent: 6,
        // Internal identifier (ID is internal to a given structrure)
        // For id relative to a different structures of the current user:
        IdentifierType_InternalIdentifierAdeli: 7,
        IdentifierType_InternalIdentifierFiness: 8,
        IdentifierType_InternalIdentifierSiren: 9,
        IdentifierType_InternalIdentifierSiret: 10,
        IdentifierType_InternalIdentifierRpps: 11,
        // For id relative to the current structure:
        IdentifierType_InternalIdentifier: 12,
    },
}

export default DMPConnect
